export default __webpack_public_path__ + "media/images/logos/faset-logo-66e2f29e7cabcde889e1788d53cfd790.png";